var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amui-textarea",class:{
    'amui-textarea--responsive': _vm.viewport === null
  }},[_c('div',{staticClass:"amui-textarea__wrapper",class:{
      'amui-textarea__wrapper--focus': _vm.focused
    }},[_c('textarea',{staticClass:"amui-textarea__textarea",attrs:{"rows":_vm.rows,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){return _vm.$emit('input', $event.target.value)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }